/**
 * Галерея видео с превью и lightbox
 */

import { useState } from 'react';
import { VideoPreview } from './VideoPreview';
import { VideoLightbox } from './VideoLightbox';
import styles from './VideoGallery.module.css';

/**
 * Элемент галереи видео
 */
export interface GalleryVideo {
  /** YouTube URL */
  url: string;
  /** Подпись к видео */
  caption?: string;
}

interface VideoGalleryProps {
  /** Массив видео */
  videos: GalleryVideo[];
}

/**
 * Галерея YouTube видео с превью и popup плеером
 */
export function VideoGallery({ videos }: VideoGalleryProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const handleOpen = (index: number) => {
    setActiveIndex(index);
  };

  const handleClose = () => {
    setActiveIndex(null);
  };

  const handlePrevious = () => {
    if (activeIndex !== null && activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const handleNext = () => {
    if (activeIndex !== null && activeIndex < videos.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  if (videos.length === 0) {
    return null;
  }

  return (
    <>
      <div className={styles.gallery}>
        {videos.map((video, index) => (
          <VideoPreview
            key={`${video.url}-${index}`}
            url={video.url}
            caption={video.caption}
            onClick={() => handleOpen(index)}
          />
        ))}
      </div>

      {activeIndex !== null && (
        <VideoLightbox
          url={videos[activeIndex].url}
          caption={videos[activeIndex].caption}
          onClose={handleClose}
          onPrevious={handlePrevious}
          onNext={handleNext}
          hasPrevious={activeIndex > 0}
          hasNext={activeIndex < videos.length - 1}
        />
      )}
    </>
  );
}

